import { Button, Form, Input } from 'antd'
import { memo, useCallback } from 'react'
import { Position } from 'types/positions'

type Props = {
    position: Position
    onSubmit: (position: Position) => void
    loading: boolean
}

export const PositionForm = memo((props: Props) => {
    const { position, onSubmit, loading } = props

    const onFinish = useCallback(
        (values: Position) => {
            onSubmit(values)
        },
        [onSubmit]
    )

    return (
        <Form
            name='basic'
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete='off'
            disabled={loading}
        >
            <Form.Item
                initialValue={position.name}
                label='Name'
                name='name'
                rules={[{ required: true, message: 'Please input position name!' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                initialValue={position.short_name}
                label='Short name'
                name='short_name'
                rules={[
                    { required: true, message: 'Please input position short name!' },
                    {
                        max: 3,
                        message: 'Short name cannot be longer than 3 characters',
                    },
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type='primary' htmlType='submit'>
                    Submit
                </Button>
                <Button htmlType={'reset'}>Reset</Button>
            </Form.Item>
        </Form>
    )
})
